import React from "react";
import { Link } from "gatsby";

const H2 = ({ text, path }) => {
  if (path) {
    return (
      <h2 className="border-b border-neutral text-2xl my-8 font-bold pb-1">
        <Link to={path} className="hover:text-primary">
          {text} <i className="fa fa-link text-sm" />
        </Link>
      </h2>
    );
  } else {
    return (
      <h2 className="border-b border-neutral text-2xl my-8 font-bold pb-1">
        {text}
      </h2>
    );
  }
};

export default H2;
